import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  container: {
    backgroundColor: 'var(--card-button-carousel__color)',
    '& > div:last-child': {
      // paddingTop: '0 !important'
    },
    '& > div:first-child': {
      paddingTop: '15px !important'
    }
  }
})

export default useStyles
